import React, { useState } from "react";
import { Formik, Form, Field, FormikConfig } from "formik";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { TextField as FormikTextField } from "formik-material-ui";
import {
  Autocomplete,
  AutocompleteRenderInputParams,
} from "formik-material-ui-lab";
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "formik-material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  Button,
  CircularProgress,
  makeStyles,
  TextField,
} from "@material-ui/core";
import ruLocale from "date-fns/locale/ru";
import PlacesAutocomplete, { Suggestion } from "react-places-autocomplete";

import { Values } from "../types";

const useStyles = makeStyles(() => ({
  form: {
    width: "100%",
    maxWidth: 320,

    display: "grid",
    gap: "16px",
  },
}));

export default function UserForm(
  props: FormikConfig<Values>
): React.ReactElement {
  const classes = useStyles();

  const [address, setAddress] = useState<string>();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
      <Formik {...props}>
        {({ errors, touched, submitForm, isSubmitting }) =>
          isSubmitting ? (
            <CircularProgress />
          ) : (
            <Form className={classes.form}>
              <Field
                name="name"
                label="Ваше имя"
                component={FormikTextField}
                inputProps={{ maxLength: 16 }}
              />

              <Field
                name="date"
                component={KeyboardDatePicker}
                label="Дата рождения"
                format="dd.MM.yyyy"
                placeholder="31.12.1990"
              />

              <PlacesAutocomplete value={address} onChange={setAddress}>
                {({ getInputProps, suggestions }) => (
                  <Field
                    name="place"
                    component={Autocomplete}
                    options={suggestions}
                    clearOnBlur={false}
                    getOptionLabel={(option: Suggestion) => option.description}
                    renderInput={(params: AutocompleteRenderInputParams) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          ...getInputProps(),
                        }}
                        error={touched.place && !!errors.place}
                        helperText={errors.place}
                        label="Место рождения"
                      />
                    )}
                  />
                )}
              </PlacesAutocomplete>

              <Field
                name="time"
                ampm={false}
                component={KeyboardTimePicker}
                label="Точное время рождения"
                placeholder="00:00"
              />

              <Button variant="contained" onClick={submitForm}>
                Отправить
              </Button>
            </Form>
          )
        }
      </Formik>
    </MuiPickersUtilsProvider>
  );
}
